<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,792.5c0-2.69-1.18-5.31-2.93-7.07c-1.76-1.75-4.38-2.93-7.07-2.93s-5.31,1.17-7.07,2.93
	c-1.75,1.76-2.93,4.38-2.93,7.07c0,2.69,1.18,5.31,2.93,7.07c1.76,1.75,4.38,2.93,7.07,2.93s5.31-1.17,7.07-2.93
	C9.32,797.81,10.5,795.19,10.5,792.5L10.5,792.5z M8.5,792.5c0,2.28-0.84,4.15-2.34,5.66c-1.5,1.5-3.38,2.34-5.66,2.34
	s-4.15-0.84-5.66-2.34c-1.5-1.5-2.34-3.38-2.34-5.66c0-2.28,0.84-4.15,2.34-5.66c1.5-1.5,3.38-2.34,5.66-2.34s4.15,0.84,5.66,2.34
	C7.66,788.35,8.5,790.22,8.5,792.5z M6.5,792.5c0,2.14-1.14,4.12-3,5.2l-1.5-2.6c0.93-0.53,1.5-1.52,1.5-2.59L6.5,792.5z
	 M-2.5,792.5c0,1.07,0.57,2.06,1.5,2.59l-1.5,2.6c-1.86-1.07-3-3.05-3-5.2H-2.5z M3.5,787.3L2,789.9c-0.45-0.26-0.97-0.4-1.5-0.4
	c-0.53,0-1.04,0.14-1.5,0.4l-1.5-2.6c0.87-0.5,1.86-0.78,2.86-0.8C1.46,786.48,2.54,786.75,3.5,787.3z M1.5,792.5c0-0.55-0.45-1-1-1
	l0,0c-0.55,0-1,0.45-1,1l0,0c0,0.55,0.45,1,1,1l0,0C1.05,793.5,1.5,793.05,1.5,792.5L1.5,792.5z M2.45,792.5
	c0-0.47-0.27-1.08-0.57-1.38c-0.3-0.3-0.91-0.57-1.38-0.57s-1.08,0.27-1.38,0.57c-0.3,0.3-0.57,0.91-0.57,1.38
	c0,0.47,0.27,1.08,0.57,1.38c0.3,0.3,0.91,0.57,1.38,0.57s1.08-0.27,1.38-0.57C2.18,793.58,2.45,792.97,2.45,792.5L2.45,792.5z
	 M0.56,792.5c0,0.01,0,0.02,0,0.02c-0.01,0-0.01,0.01-0.02,0.02c-0.01,0.01-0.02,0.01-0.02,0.02c0,0-0.01,0-0.02,0s-0.02,0-0.02,0
	c0-0.01-0.01-0.01-0.02-0.02c-0.01-0.01-0.01-0.01-0.02-0.02c0,0,0-0.01,0-0.02c0-0.01,0-0.02,0-0.02c0.01,0,0.01-0.01,0.02-0.02
	c0.01-0.01,0.02-0.01,0.02-0.02c0,0,0.01,0,0.02,0s0.02,0,0.02,0c0,0.01,0.01,0.01,0.02,0.02c0.01,0.01,0.01,0.01,0.02,0.02
	C0.56,792.48,0.56,792.49,0.56,792.5z"/>
</svg>

</template>